import { useDispatch, useSelector } from 'react-redux';
import { memo, useEffect, useState } from 'react';
import { useAnalytics } from 'use-analytics';
import { SearchStatus } from '../../../constants';
import { resetSendCustomerQueryStatus, sendCustomerQueryRequest } from '../../../store/slices/user';
import EmailToClientForm from '../../EmailToClientForm';

const ContactAdvisorEmailForm = () => {
  const initialMessage = `Dear Travel Advisor,

I'm looking for assistance with a trip.

Regards,`;

  const {
    sendCustomerQueryStatus, sendCustomerQueryError, travelAgency,
  } = useSelector((state) => state.user);
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState(initialMessage);

  const dispatch = useDispatch();
  const { track } = useAnalytics();

  const onSendClick = () => {
    dispatch(sendCustomerQueryRequest({
      customerName,
      customerEmail,
      customerPhoneNumber: phoneNumber,
      phoneNumber,
      message,
      resultsPage: window.location.href,
    }));
    track('ContactAdvisorEmailForm.onSendClick');
  };

  const handleInputChange = (event) => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;
    if (fieldName === 'customerName') {
      const defaultContactTravelText = travelAgency && travelAgency.defaultContactTravelText
        ? travelAgency.defaultContactTravelText : initialMessage;
      if (fieldValue && message.includes(defaultContactTravelText)) {
        setMessage(`${defaultContactTravelText}
${fieldValue}`);
      }
      setCustomerName(fieldValue);
    }
    if (fieldName === 'fromEmail') setCustomerEmail(fieldValue);
    if (fieldName === 'customerPhoneNumber') setPhoneNumber(fieldValue);
    if (fieldName === 'emailMessage') setMessage(fieldValue);
  };

  useEffect(() => {
    dispatch(resetSendCustomerQueryStatus());
    if (travelAgency && travelAgency.defaultContactTravelText) {
      setMessage(travelAgency.defaultContactTravelText);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <EmailToClientForm
        customerName={customerName}
        customerEmail={customerEmail}
        customerPhoneNumber={phoneNumber}
        onInputChange={handleInputChange}
        doEnableSend={sendCustomerQueryStatus !== SearchStatus.SEARCHING}
        onSendClick={onSendClick}
        sendStatus={sendCustomerQueryStatus}
        sendError={sendCustomerQueryError}
        sendLabel="Submit"
        emailMessage={message}
      />
    </div>
  );
};

export default memo(ContactAdvisorEmailForm);
